import MenuComponent from "../component/MenueComponent";
import NachEvent from "./component/NachEvent";
import { MyFooter } from "./MyFooter";

export function LandingPage() {

  return (
    <>

      <div className="max-w-7xl mx-auto">

        <MenuComponent aktuelleseite="startseite" />

        {/*<Ankuendigung />*/}
        <NachEvent />

        <MyFooter />

      </div>
    </>
  );
}

export default LandingPage;